import {useCallback, useEffect, useState} from 'react';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

import http from 'services/http';
import calcularGrupo from 'utils/calcularGrupo';
import {useLoading} from '../../../../hook/loading';
import {alerta} from "../../../../components/Alert";

export default function Adicionar({location, history}) {
    const [loading, startLoading, stopLoading] = useLoading();

    const [data, setData] = useState('');
    const [loteria, setLoteria] = useState(null);
    const [resultados, setResultados] = useState([]);  // 5 primeiros (base)
    const [extras1ao7, setExtras1ao7] = useState(['', '']);  // posições 6 e 7
    const [extras1ao10, setExtras1ao10] = useState(['', '', '', '', '']);  // posições 6 a 10
    const [resultadosGrupo, setResultadoGrupos] = useState([]);

    const aoIniciar = useCallback(() => {
        if (location && location.loteria && location.data) {
            const lot = location.loteria;
            const dat = location.data;

            setLoteria(lot);
            setData(dat);

            if (lot.resultado) {
                // Os 5 primeiros vêm do campo 'resultados' (sempre)
                const base = (lot.resultado.resultados || []).slice(0, 5);
                setResultados(base);

                // Extras 1_ao_7: posições 6 e 7 (índices 5 e 6 do array completo)
                const arr1ao7 = lot.resultado['1_ao_7'] || [];
                setExtras1ao7([arr1ao7[5] ?? '', arr1ao7[6] ?? '']);

                // Extras 1_ao_10: posições 6 a 10 (índices 5 a 9)
                const arr1ao10 = lot.resultado['1_ao_10'] || [];
                setExtras1ao10([
                    arr1ao10[5] ?? '',
                    arr1ao10[6] ?? '',
                    arr1ao10[7] ?? '',
                    arr1ao10[8] ?? '',
                    arr1ao10[9] ?? '',
                ]);
            } else {
                setResultados([]);
                setExtras1ao7(['', '']);
                setExtras1ao10(['', '', '', '', '']);
            }
        }
    }, [location]);

    useEffect(() => {
        aoIniciar();
    }, [aoIniciar]);

    useEffect(() => {
        const rg = resultados.map((r) => calcularGrupo(r, location.tipo));
        setResultadoGrupos(rg);
    }, [resultados]);

    const mudarResultado = (jogo, numero) => {
        const arr = resultados.map((r) => r);
        // Para loteria federal com 7 sorteios, aceita 5 dígitos, senão aceita 4
        const maxDigitos = (loteria?.loteria_federal && loteria?.quantidade_sorteios === 7) ? 5 : 4;
        if (numero.length <= maxDigitos) {
            arr[jogo] = numero;
            setResultados(arr);
        }
    };

    const maxDigitos = (loteria?.loteria_federal && loteria?.quantidade_sorteios === 7) ? 5 : 4;

    // Calcula o grupo (animal) de qualquer número
    const grupoDe = (numero) => calcularGrupo(numero, location?.tipo) || '';

    // Move foco pro próximo input quando atinge o tamanho máximo
    const pularProximo = (valor, proximoId, max = maxDigitos) => {
        if (valor.length >= max && proximoId) {
            setTimeout(() => {
                const next = document.getElementById(proximoId);
                if (next) {
                    next.focus();
                    next.select?.();
                }
            }, 0);
        }
    };

    // const inputsResultados = useCallback(() => {
    //   //
    //   const array = [];
    //   for (let i = 0; i < loteria.quantidade_sorteios; i++) {
    //     array.push(
    //       <div key={i} className="form-group d-flex tres-colunas">
    //         <div style={{ width: "50px" }}>{i === 9 ? 10 : "0" + (i + 1)}</div>
    //         <input
    //           type="number"
    //           className="form-control"
    //           onChange={(event) => mudarResultado(i, event.target.value)}
    //           value={resultados[i] || ''}
    //         />
    //         <div>{resultadosGrupo[i]}</div>
    //       </div>
    //     );
    //   }
    //   return array;
    // }, [loteria.quantidade_sorteios, resultados, resultadosGrupo]);

    // update history
    if (location.loteria === undefined) {
        history.push('/resultado/');
        return <span>Redirecionando para resultados disponíveis</span>;
    }

    async function enviarResultado() {
        startLoading();

        // Os 5 primeiros (base) são obrigatórios
        const baseFaltando = [0, 1, 2, 3, 4].some(i => !resultados[i]);
        if (baseFaltando) {
            stopLoading();
            Swal.fire({type: 'error', title: 'Preencha os 5 primeiros resultados!'});
            return;
        }

        const maxValor = (loteria?.loteria_federal && loteria?.quantidade_sorteios === 7) ? 99999 : 9999;
        const todosValidos = resultados.slice(0, 5).every(v => Number(v) >= 0 && Number(v) <= maxValor);
        if (!todosValidos) {
            stopLoading();
            Swal.fire({type: 'error', title: 'Resultado inválido!'});
            return;
        }

        try {
            const payload = {
                data_resultado: data,
                resultados: resultados.slice(0, 5),
                '1_ao_7': extras1ao7.some(Boolean) ? [...resultados.slice(0, 5), ...extras1ao7] : [],
                '1_ao_10': extras1ao10.some(Boolean) ? [...resultados.slice(0, 5), ...extras1ao10] : [],
            };

            const response = await http.post(
                location.tipo + '/extracoes/' + loteria.id + '/resultado',
                payload,
                {
                    cache: {
                        maxAge: 60 * 1000,
                        exclude: {query: false}
                    }
                }
            );

            stopLoading();
            alerta(response.data);
            history.push('/resultado/');
        } catch (e) {
            stopLoading();
            alerta(e.response.data);
        }
    }

    // valida o negativo (doidera!!!??? by ari)
    function validar(numero) {
        const tamanhoEsperado = (loteria?.loteria_federal && loteria?.quantidade_sorteios === 7) ? 5 : 4;
        return `${numero}`.length !== tamanhoEsperado;
    }

    async function gerarResultado() {
        // Validação dos 5 primeiros resultados
        if (
            validar(resultados[0]) ||
            validar(resultados[1]) ||
            validar(resultados[2]) ||
            validar(resultados[3]) ||
            validar(resultados[4])
        ) {
            Swal.fire({
                type: 'error',
                title: 'Adicione os 5 primeiros resultados !'
            });

            return false;
        }

        // Cálculo do 1 AO 7 (federal): 6º = soma dos 5; 7º = produto dos 2 primeiros sem últimos 3
        const digitos = loteria?.loteria_federal ? 5 : 4;
        const baseFormatada = resultados.slice(0, 5).map(n => String(n).padStart(digitos, '0'));
        const baseInt = baseFormatada.map(n => parseInt(n));

        const soma = baseInt.reduce((acc, n) => acc + n, 0);
        const sexto = String(soma).slice(-4).padStart(4, '0');

        const produto = baseInt[0] * baseInt[1];
        const setimo = String(produto).slice(0, -3).slice(-3).padStart(3, '0');

        setExtras1ao7([sexto, setimo]);

        // Cálculo do 1 AO 10 (lógica antiga, baseada em fatias dos 4 primeiros)
        const novo10 = ['', '', '', '', ''];
        novo10[0] = resultados[0].slice(0, -3) + resultados[1].slice(0, -3) +
                    resultados[2].slice(0, -3) + resultados[3].slice(0, -3);
        novo10[1] = resultados[0].slice(1, -2) + resultados[1].slice(1, -2) +
                    resultados[2].slice(1, -2) + resultados[3].slice(1, -2);
        novo10[2] = resultados[0].slice(2, -1) + resultados[1].slice(2, -1) +
                    resultados[2].slice(2, -1) + resultados[3].slice(2, -1);
        novo10[3] = resultados[0].slice(3) + resultados[1].slice(3) +
                    resultados[2].slice(3) + resultados[3].slice(3);

        const somaTodos = baseInt.reduce((a, b) => a + b, 0)
            + parseInt(novo10[0] || 0) + parseInt(novo10[1] || 0)
            + parseInt(novo10[2] || 0) + parseInt(novo10[3] || 0);
        novo10[4] = String(somaTodos).slice(-4);

        setExtras1ao10(novo10);
    }

    async function simularResultado() {
        startLoading();

        const baseFaltando = [0, 1, 2, 3, 4].some(i => !resultados[i]);
        if (baseFaltando) {
            stopLoading();
            Swal.fire({type: 'error', title: 'Preencha os 5 primeiros resultados!'});
            return;
        }

        const maxValor = (loteria?.loteria_federal && loteria?.quantidade_sorteios === 7) ? 99999 : 9999;
        const todosValidos = resultados.slice(0, 5).every(v => Number(v) >= 0 && Number(v) <= maxValor);
        if (!todosValidos) {
            stopLoading();
            Swal.fire({type: 'error', title: 'Resultado inválido!'});
            return;
        }

        try {
            const payload = {
                data_resultado: data,
                resultados: resultados.slice(0, 5),
                '1_ao_7': extras1ao7.some(Boolean) ? [...resultados.slice(0, 5), ...extras1ao7] : [],
                '1_ao_10': extras1ao10.some(Boolean) ? [...resultados.slice(0, 5), ...extras1ao10] : [],
            };

            const response = await http.post(
                location.tipo + '/extracoes/' + loteria.id + '/simular-resultado',
                payload,
                {
                    cache: {
                        maxAge: 60 * 1000,
                        exclude: {query: false}
                    }
                }
            );
            alerta(response.data);

            Swal.fire({
                type: 'info',
                title: 'Premio: ' + response.data.data.premio.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                })
            });

            stopLoading();
        } catch (e) {
            alerta(e.response.data);
            stopLoading();
        }
    }

    return (
        <>
            <div className="titulo-principal">
                {loteria && loteria.nome} -&nbsp;
                {dayjs(data).format('DD/MM/YYYY')}
            </div>
            <div className="conteudo-principal">
                <div style={{display: 'flex', gap: '4px', flexWrap: 'wrap', justifyContent: 'flex-start'}}>

                    {/* Coluna 1 AO 5 (base, editável) */}
                    <div style={{flex: '0 0 auto'}}>
                        <h6 className="mb-3"><strong>1 AO 5</strong></h6>
                        {[0, 1, 2, 3, 4].map((i) => (
                            <div key={i} className="mb-2" style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
                                <span style={{width: 24, textAlign: 'right', fontWeight: 'bold', flexShrink: 0}}>
                                    {String(i + 1).padStart(2, '0')}
                                </span>
                                <input
                                    id={`base-${i}`}
                                    type="number"
                                    inputMode="numeric"
                                    className="form-control"
                                    onChange={(event) => {
                                        mudarResultado(i, event.target.value);
                                        pularProximo(event.target.value, i < 4 ? `base-${i + 1}` : 'e7-0');
                                    }}
                                    value={resultados[i] || ''}
                                    maxLength={maxDigitos}
                                    style={{width: 75, flexShrink: 0, textAlign: 'center'}}
                                />
                                <small style={{color: '#666', width: 70, flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                    {resultadosGrupo[i]}
                                </small>
                            </div>
                        ))}
                    </div>

                    {/* Coluna 1 AO 7 */}
                    <div style={{flex: '0 0 auto'}}>
                        <h6 className="mb-3"><strong>1 AO 7</strong></h6>
                        {[0, 1, 2, 3, 4, 5, 6].map((i) => {
                            const isReadonly = i < 5;
                            const value = isReadonly
                                ? (resultados[i] || '')
                                : (extras1ao7[i - 5] || '');
                            const inputId = isReadonly ? null : `e7-${i - 5}`;
                            const proximoId = !isReadonly && i < 6 ? `e7-${i - 5 + 1}` : (i === 6 ? 'e10-0' : null);
                            // 7º prêmio aceita só 3 dígitos
                            const maxLen = i === 6 ? 3 : maxDigitos;

                            return (
                                <div key={i} className="mb-2" style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
                                    <span style={{width: 24, textAlign: 'right', fontWeight: 'bold', flexShrink: 0}}>
                                        {String(i + 1).padStart(2, '0')}
                                    </span>
                                    <input
                                        id={inputId || undefined}
                                        type="number"
                                        inputMode="numeric"
                                        className="form-control"
                                        readOnly={isReadonly}
                                        value={value}
                                        onChange={(event) => {
                                            if (isReadonly) return;
                                            const v = event.target.value.slice(0, maxLen);
                                            const novo = [...extras1ao7];
                                            novo[i - 5] = v;
                                            setExtras1ao7(novo);
                                            pularProximo(v, proximoId, maxLen);
                                        }}
                                        maxLength={maxLen}
                                        style={{
                                            width: 75,
                                            flexShrink: 0,
                                            textAlign: 'center',
                                            backgroundColor: isReadonly ? '#e9ecef' : 'white'
                                        }}
                                    />
                                    <small style={{color: '#666', width: 70, flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                        {grupoDe(value)}
                                    </small>
                                </div>
                            );
                        })}
                    </div>

                    {/* Coluna 1 AO 10 */}
                    <div style={{flex: '0 0 auto'}}>
                        <h6 className="mb-3"><strong>1 AO 10</strong></h6>
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => {
                            const isReadonly = i < 5;
                            const value = isReadonly
                                ? (resultados[i] || '')
                                : (extras1ao10[i - 5] || '');
                            const inputId = isReadonly ? null : `e10-${i - 5}`;
                            const proximoId = !isReadonly && i < 9 ? `e10-${i - 5 + 1}` : null;
                            // Todos os campos do 1 AO 10 aceitam só 4 dígitos
                            const maxLen = 4;

                            return (
                                <div key={i} className="mb-2" style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
                                    <span style={{width: 24, textAlign: 'right', fontWeight: 'bold', flexShrink: 0}}>
                                        {String(i + 1).padStart(2, '0')}
                                    </span>
                                    <input
                                        id={inputId || undefined}
                                        type="number"
                                        inputMode="numeric"
                                        className="form-control"
                                        readOnly={isReadonly}
                                        value={value}
                                        onChange={(event) => {
                                            if (isReadonly) return;
                                            const v = event.target.value.slice(0, maxLen);
                                            const novo = [...extras1ao10];
                                            novo[i - 5] = v;
                                            setExtras1ao10(novo);
                                            pularProximo(v, proximoId, maxLen);
                                        }}
                                        maxLength={maxLen}
                                        style={{
                                            width: 75,
                                            flexShrink: 0,
                                            textAlign: 'center',
                                            backgroundColor: isReadonly ? '#e9ecef' : 'white'
                                        }}
                                    />
                                    <small style={{color: '#666', width: 70, flexShrink: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                        {grupoDe(value)}
                                    </small>
                                </div>
                            );
                        })}
                    </div>

                </div>
                {/*  */}
                <div className="d-flex m-t" style={{ justifyContent: 'start', gap: '10px' }}>
                    <button
                        className="btn btn-warning"
                        onClick={() => simularResultado()}
                        disabled={loading}
                    >
                        Simular resultado
                    </button>

                    <button
                        className="btn btn-info"
                        onClick={() => gerarResultado()}
                        disabled={loading}
                    >
                        Gerar resultados
                    </button>

                    <button
                        className="btn btn-primary"
                        onClick={() => enviarResultado()}
                        disabled={loading}
                    >
                        {!loading ? 'Salvar' : 'Aguarde...'}
                    </button>
                </div>
            </div>
        </>
    );
}
